(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('dateFacilityGrid', dateFacilityGridDirective)
    .controller('dateFacilityGridController', dateFacilityGridController);

  /** @ngInject */
  function dateFacilityGridDirective () {
    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      templateUrl: 'app/components/dateFacilityGrid/dateFacilityGrid.html',
      controller: 'dateFacilityGridController',
      controllerAs: 'vm',
      link: function (scope) {
        scope.vm.refresh(scope.data);
        scope.$watch('data', function (newValue) {
          scope.vm.refresh(newValue);
        });
      }
    }
  }

  /** @ngInject */
  function dateFacilityGridController ($scope, gridUtils) {
    var vm = this;

    vm.count = 0;
    vm.currentPage = 1;
    vm.refresh = refreshGridData;

    init();

    function init () {
      var gridSettings = gridUtils.getDefaultGridSettings();
      vm.limitPerPage = gridSettings.limitPerPage;
      vm.pagerLabel = gridSettings.translations;

      $scope.$on('$destroy', destroy);
    }

    function destroy () {

    }

    function refreshGridData (data) {
      if (data === null) {
        return;
      }

      vm.count = data.dates.length;
      vm.columns = ["DATE"].concat(data.facilities);
      vm.rowsData = data.dates.map(function (dateItem) {
        return {
          date: dateItem.date,
          dateFormatted: dateItem.date, //todo format
          values: dateItem.values
        }
      });
    }
  }
})();
